// PayslipPdf.js
import { Image, Text, View } from "@react-pdf/renderer";
import React from "react";
import email from "../../assets/icons/email.png";
import location from "../../assets/icons/location.png";
import call from "../../assets/icons/phone.png";
import Logo from "../../assets/image/logo512.png";
import { fonts, reportStyles } from "./report-style";
fonts();

const ReportHeader1 = ({ organization_info }) => {

  return (
    <View>
      <View style={reportStyles.pdfHeader} fixed>
      {/* Organization Logo */}
      <View style={reportStyles.PdfLogo}>
        <Image
          src={organization_info?.logo ? `data:image/png;base64,${organization_info.base64logo}` : Logo}
          alt="Logo"
          style={reportStyles.Logo}
        />
      </View>

      {/* Organization Details */}
      {organization_info && (
        <View style={reportStyles.HeaderDescription}>
          {organization_info?.org_name && (
            <Text style={reportStyles.HeaderHeading}>{organization_info?.org_name}</Text>
          )}

          {(organization_info?.address || organization_info?.locality || organization_info?.landmark ||
            organization_info?.city || organization_info?.state || organization_info?.country || organization_info?.pincode) && (
            <View style={[reportStyles.HeaderLocation, { marginBottom: "10px" }]}>
              <Image src={location} alt="location" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
              <Text>
                {organization_info?.address ? organization_info.address + ", " : ""}
                {organization_info?.locality ? organization_info.locality + ", " : ""}
                {organization_info?.landmark ? organization_info.landmark + ", " : ""}
                {organization_info?.city ? organization_info.city + ", " : ""}
                {organization_info?.state ? organization_info.state + ", " : ""}
                {organization_info?.country ? organization_info.country + " " : ""}
                {organization_info?.pincode ? organization_info.pincode : ""}
              </Text>
            </View>
          )}

          <View style={reportStyles.HeaderLocation}>
            {/* Phone Number */}
            {(organization_info?.phone || organization_info?.landline) && (
              <View style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "row" }}>
                <Image src={call} alt="call" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
                <Text>{organization_info?.phone || organization_info?.landline}</Text>
              </View>
            )}

            {/* Email Address */}
            {organization_info?.email && (
              <View style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "row" }}>
                <Image src={email} alt="email" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
                <Text>{organization_info?.email}</Text>
              </View>
            )}
          </View>
        </View>
      )}
    </View>
    <View style={reportStyles.gap}/>

    </View>
   
  );
};

export default ReportHeader1;
